<template>
  <div class="models">
    <h1>车型页面</h1>
    <p>这是车型展示页面，实际开发中会显示所有汽车车型</p>
  </div>
</template>

<script>
export default {
  name: 'Models'
}
</script>

<style scoped>
.models {
  padding: 20px;
}
</style> 